import React, { useEffect, useState } from "react";
import axios from "axios";
import { motion, AnimatePresence } from "framer-motion";
import {
  FiEye,
  FiEyeOff,
  FiLock,
  FiLogOut,
} from "react-icons/fi";

import fondo from "../assets/fondo1.jpg";

import ReservaCard from "./ConsultasCard";
import Spinner from "../layout/Spinner";
import FloatingAdminMenu from "./FloatMenu";

const API = "https://aldanaselena.com/reservas.php";
const PASSWORD = "aldana.admin";

const AdminConsultas = ({ setModalAbierto }) => {
  const [reservas, setReservas] = useState([]);
  const [loading, setLoading] = useState(false);
  const [status, setStatus] = useState("");
  const [showMenu, setShowMenu] = useState(false);

  // AUTH
  const [isAuth, setIsAuth] = useState(false);
  const [passwordInput, setPasswordInput] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [errorAuth, setErrorAuth] = useState("");

  // SESSION
  useEffect(() => {
    const savedAuth = localStorage.getItem("admin_auth");

    if (savedAuth === "true") {
      setIsAuth(true);
    }
  }, []);

  const handleLogin = () => {
    if (passwordInput === PASSWORD) {
      setIsAuth(true);
      localStorage.setItem("admin_auth", "true");
      setErrorAuth("");
    } else {
      setErrorAuth("Contraseña incorrecta");
    }
  };

  const handleLogout = () => {
    localStorage.removeItem("admin_auth");
    setIsAuth(false);
  };

  const fetchReservas = async () => {
    try {
      setLoading(true);

      const res = await axios.get(API);

      setReservas(res.data);
    } catch (err) {
      console.error(err);
      setStatus("Error al cargar");
    }

    setLoading(false);
  };

  useEffect(() => {
    if (isAuth) {
      fetchReservas();
    }
  }, [isAuth]);

  const handleDelete = async (id) => {
    if (!window.confirm("¿Eliminar reserva?")) return;

    try {
      await axios.delete(`${API}?id=${id}`);

      setReservas((prev) => prev.filter((r) => r.id !== id));
    } catch (err) {
      console.error(err);
      setStatus("Error al eliminar");
    }
  };

  const handleUpdate = async (id, data) => {
    try {
      await axios.put(`${API}?id=${id}`, data);

      setStatus("Actualizado");

      fetchReservas();
    } catch (err) {
      console.error(err);
      setStatus("Error al actualizar");
    }
  };

  return (
    <div className="relative min-h-screen w-full overflow-hidden">
      {/* FONDO */}
      <img
        src={fondo}
        className="absolute inset-0 w-full h-full object-cover"
        alt="bg"
      />

      <div className="absolute inset-0 bg-[#0E0B09]/90 backdrop-blur-sm" />
      <div className="flex justify-between items-center mb-10">
            <div>
              <h1
                className="
                text-2xl sm:text-4xl
                text-[#B8977F]
                tracking-[0.2em]
                "
              >
                MENTORÍAS
              </h1>

              <div className="w-24 h-px bg-[#B8977F]/30 mt-4" />
            </div>

            <button
              onClick={handleLogout}
              className="
              flex items-center gap-2
              border border-[#B8977F]/30
              px-4 py-3
              rounded-2xl
              text-[#B8977F]
              hover:bg-[#B8977F]/10
              transition
              "
            >
              <FiLogOut />
              Salir
            </button>
          </div>
      {/* LOGIN */}
      <AnimatePresence>
        {!isAuth && (
          <motion.div
            className="fixed inset-0 z-[99999] flex items-center justify-center px-4"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
          >
            <div className="absolute inset-0 bg-black/70 backdrop-blur-sm" />

            <motion.div
              initial={{ scale: 0.85, opacity: 0 }}
              animate={{ scale: 1, opacity: 1 }}
              exit={{ scale: 0.85, opacity: 0 }}
              className="
              relative z-10
              bg-[#1a1411]
              border border-[#B8977F]/30
              rounded-3xl
              p-7
              w-full max-w-sm
              shadow-2xl
              "
            >
              <div className="flex items-center gap-3 mb-6 text-[#B8977F]">
                <div className="p-2 rounded-xl bg-[#B8977F]/10">
                  <FiLock size={20} />
                </div>

                <h2 className="text-lg tracking-[0.2em]">
                  ACCESO ADMIN
                </h2>
              </div>

              <div className="relative">
                <input
                  type={showPassword ? "text" : "password"}
                  value={passwordInput}
                  onChange={(e) => setPasswordInput(e.target.value)}
                  placeholder="Contraseña"
                  className="
                  w-full
                  bg-black/40
                  border border-[#B8977F]/20
                  text-white
                  px-4 py-3
                  rounded-2xl
                  outline-none
                  focus:border-[#B8977F]/50
                  transition
                  "
                />

                <button
                  onClick={() => setShowPassword(!showPassword)}
                  className="
                  absolute right-4 top-1/2 -translate-y-1/2
                  text-[#B8977F]
                  "
                >
                  {showPassword ? <FiEyeOff /> : <FiEye />}
                </button>
              </div>

              {errorAuth && (
                <p className="text-red-400 text-sm mt-3">
                  {errorAuth}
                </p>
              )}

              <button
                onClick={handleLogin}
                className="
                mt-5
                w-full
                bg-[#B8977F]
                text-black
                py-3
                rounded-2xl
                hover:opacity-80
                transition
                font-medium
                tracking-wide
                "
              >
                Ingresar
              </button>
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>

      {/* MENÚ FLOTANTE */}
      {isAuth && (
        <FloatingAdminMenu
          showMenu={showMenu}
          setShowMenu={setShowMenu}
        />
      )}

      {/* CONTENIDO */}
      {isAuth && (
        <div className="relative z-10 max-w-7xl mx-auto p-6 md:p-12">
          {/* HEADER */}
          <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-6 mb-10">
            <motion.div
              initial={{ opacity: 0, y: -15 }}
              animate={{ opacity: 1, y: 0 }}
            >
              <h1
                className="
                text-3xl md:text-5xl
                text-[#B8977F]
                tracking-[0.25em]
                "
              >
                PANEL DE CONSULTAS
              </h1>

              <div className="w-32 h-px bg-[#B8977F]/30 mt-4" />
            </motion.div>

            <button
              onClick={handleLogout}
              className="
              flex items-center gap-2
              self-start
              border border-[#B8977F]/30
              px-5 py-3
              rounded-2xl
              text-[#B8977F]
              hover:bg-[#B8977F]/10
              transition
              "
            >
              <FiLogOut />
              Salir
            </button>
          </div>

          {/* STATUS */}
          {status && (
            <p className="text-[#B8977F] mb-6 text-center">
              {status}
            </p>
          )}

          {/* LOADING */}
          {loading ? (
            <div className="flex justify-center py-20">
              <Spinner />
            </div>
          ) : reservas.length === 0 ? (
            <div className="flex flex-col items-center justify-center py-24 text-center">
              <p
                className="
                text-[#B8977F]
                text-lg md:text-xl
                tracking-[0.2em]
                "
              >
                AÚN NO HAY CONSULTAS
              </p>

              <div className="w-20 h-px bg-[#B8977F]/30 mt-5" />
            </div>
          ) : (
            <div
              className="
              grid gap-6
              sm:grid-cols-1
              md:grid-cols-2
              xl:grid-cols-3
              "
            >
              {reservas.map((r) => (
                <ReservaCard
                  key={r.id}
                  reserva={r}
                  onDelete={handleDelete}
                  onUpdate={handleUpdate}
                  setModalAbierto={setModalAbierto}
                />
              ))}
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default AdminConsultas;